import Icon from '../components/Icon.vue'

Icon.register({"folder-open":{"width":1920,"height":1792,"paths":[{"d":"M1879 952q0 31-31 66l-336 396q-43 51-120.5 86.5t-143.5 35.5h-1088q-34 0-60.5-13t-26.5-43q0-31 31-66l336-396q43-51 120.5-86.5t143.5-35.5h1088q34 0 60.5 13t26.5 43zM1536 608v160h-832q-94 0-197 47.5t-164 119.5l-337 396-5 6q0-4-0.5-12.5t-0.5-12.5v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/folder-open.js
// module id = 1102
// module chunks = 0